import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import SnForm from "@widgets/SnForm";

interface popupProps {
  rowData: any;
  onSave: (data: any) => Promise<boolean>;
  modalRef?: any;
}

const getNextHst = (value: any) => {
  const noHst = Number(value ?? 0);
  return Number.isFinite(noHst) ? noHst + 1 : 1;
};

const getControlKeys = (control: any) => {
  const params = String(control.cd_param ?? "")
    .split(",")
    .map((param) => param.trim())
    .filter(Boolean);
  const displayColumn = String(control.cd_displaycolumn ?? "").trim();

  return displayColumn ? [...params, displayColumn] : params;
};

const createFormData = (rowData: any, controls: any[], defaults: any = {}) => {
  const data = controls.reduce((formData: any, control: any) => {
    getControlKeys(control).forEach((key) => {
      formData[key] = rowData?.[key] ?? defaults?.[key] ?? "";
    });
    return formData;
  }, {});

  if (Object.prototype.hasOwnProperty.call(data, "no_hst")) {
    data.no_hst = getNextHst(rowData?.no_hst);
  }
  if (Object.prototype.hasOwnProperty.call(data, "qt_cavity")) {
    data.qt_cavity =
      rowData?.qt_cavitiy ?? rowData?.qt_cavity ?? defaults?.qt_cavity ?? "";
  }

  return data;
};

const createSaveData = (formData: any, controls: any[]) =>
  controls.reduce((saveData: any, control: any) => {
    if (control.tp_ctrl === "SnLinkedInfoBox") return saveData;

    getControlKeys(control).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(formData, key)) {
        saveData[key] = formData[key];
      }
    });
    return saveData;
  }, {});

const SN_PRD_DIE_REG_001_POP_01 = forwardRef(
  ({ rowData, onSave, modalRef }: popupProps, ref) => {
    const formRef = useRef<any>(null);
    const [freeFormControls, setFreeFormControls] = useState<any[]>([]);
    const [formData, setFormData] = useState<any>({});

    useEffect(() => {
      const fetchForm = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_PRD_DIE_REG_001_POP_01",
            {}
          );
          const freeform1 = rtn.form?.freeform1 ?? [];
          const freeform1Defaults = rtn.form?.freeform1ControlData ?? {};

          setFreeFormControls(freeform1);
          setFormData(
            createFormData(rowData, freeform1, {
              ...rtn.formData,
              ...freeform1Defaults,
            })
          );
        } catch (error: any) {
          await showDialog("error", error.message);
        }
      };

      fetchForm();
    }, [rowData]);

    useImperativeHandle(ref, () => ({
      getSelectedValue: async () => {
        const data = formRef.current?.getFormdata() ?? formData;
        const saveData = createSaveData(data, freeFormControls);

        const ok = await onSave(saveData);
        return { dieHstAdd: ok };
      },
    }));

    return (
      <div className="h-full text-sm">
        <SnForm
          ref={formRef}
          data={formData}
          controls={freeFormControls}
          popupRef={modalRef}
        />
      </div>
    );
  }
);

export default SN_PRD_DIE_REG_001_POP_01;
